module.exports = "https://coursera_assets.s3.amazonaws.com/images/62d805b1bf92488bd12f43f1a386833e.png";